import request from 'request/index'
import { E_PRODUCT2_RES } from 'utils/config'
export default {
  /**
   * 3.3.3.1 获取应用绑定分享模板列表 [get] /visitor/products/app/{appid}/share_template/bind
   */
  sGetShareTemplate ({
    app_id,
    $count = false,
    $offset = 0,
    $limit = 10
  }) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/visitor/products/app/{appid}/share_template/bind',
      params: {
        appid: app_id
      },
      query: {
        $count,
        $limit,
        $offset
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/edmodo/share.js